import './App.css';
import React from "react";
import ReactDOM from "react-dom/client";

function Footer() {
  return (
    <div className="bg-ddp py-5 mt-10">
      <p className="text-center text-base font-bold mx-8">This site is not made by or affiliated with Last Quarter Studios.</p>
      <p className="text-center text-base font-bold mx-8">The Cats are Liquid series is developed and published by Last Quarter Studios.</p>
      <p className="text-center text-base">Play <a className="hover:text-darkc transition" href="https://catsareliquid.lastquarterstudios.com"><u>A Better Place</u></a></p>
      <p className="text-center text-xs mx-8 md:mx-32 lg:mx-64 mt-2">This product is not affiliated with Cats are Liquid or its owner Last Quarter Studios Limited Partnership and is not endorsed or in any way otherwise sponsored by Last Quarter Studios. Portions of the materials contained within this product are property of Last Quarter Studios Limited Partnership.</p>
      <p className="text-center text-base">Version 1.0.2</p>
    </div>
  );
}

export default Footer;